module.exports = "/call-frontend/img/icon_send.39cb0950.svg";